import { bindActionCreators } from 'redux'
import { connect } from 'react-redux'
import EntityMasters from '../../../components/masters/entity/EntityMasters'
import { translate } from 'react-polyglot'
import { openSourceChannelModal, deleteSourceChannelModal, fetchEntityMasters } from '../../../actions/masters/masters'

export function mapStateToProps (state) {
  return {
    ...state.entityMasters
  }
}

export function mapDispatchToProps (dispatch) {
  return {
    actions: bindActionCreators({
      openSourceChannelModal,
      deleteSourceChannelModal,
      fetchEntityMasters
    }, dispatch)
  }
}

export default connect(mapStateToProps, mapDispatchToProps)(translate()(EntityMasters))
